/**
 * Sticky bottom banner shown app-wide while an admin is impersonating a user
 * ("Login as user"). Lets them exit back to their own admin account.
 */
import { ShieldAlert, LogOut } from "lucide-react";
import { useMe, useStopImpersonation } from "@/hooks/useAuth";

export function ImpersonationBanner() {
  const me = useMe();
  const stop = useStopImpersonation();
  const imp = me.data?.impersonatedBy;
  if (!imp) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] flex flex-wrap items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-black shadow-[0_-4px_20px_rgba(0,0,0,0.25)]">
      <span className="flex items-center gap-2 text-sm font-medium">
        <ShieldAlert className="h-4 w-4" />
        Viewing as <strong>{me.data?.fullName}</strong>
        <span className="opacity-80">· impersonated by {imp.fullName}</span>
      </span>
      <button
        type="button"
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        className="inline-flex items-center gap-1.5 rounded-md bg-black/85 px-3 py-1.5 text-xs font-semibold text-white hover:bg-black disabled:opacity-60"
      >
        <LogOut className="h-3.5 w-3.5" /> {stop.isPending ? "Exiting…" : "Exit to admin"}
      </button>
    </div>
  );
}
